// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1fMgq","info":"PatientInfo_info__1Nev0"};